export interface KeyValue {
  key: any;
  value: any;
}

export const formatString = (str: string, ...args: KeyValue[]): string => {
  for (const k in args) {
    str = str.replace(new RegExp(`\\{${args[k].key}\\}`, "gi"), args[k].value);
  }
  return str;
};
